/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_PublishInputs */

const cs_social_export_publish = /** @type {(inputs: Social_Export_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikovat`)
};

const en_social_export_publish = /** @type {(inputs: Social_Export_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish`)
};

/**
* | output |
* | --- |
* | "Publish" |
*
* @param {Social_Export_PublishInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_publish = /** @type {((inputs?: Social_Export_PublishInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_PublishInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_publish(inputs)
	return cs_social_export_publish(inputs)
});